import { ModalStore } from '../../common/types';

const ModalInitialState: ModalStore = {
  open: false,
  variant: undefined,
};

export default ModalInitialState;
